import { render, staticRenderFns } from "./DashboardResumen.vue?vue&type=template&id=d3cb9ad6&scoped=true&lang=pug"
import script from "./DashboardResumen.vue?vue&type=script&lang=js"
export * from "./DashboardResumen.vue?vue&type=script&lang=js"
import style0 from "./DashboardResumen.vue?vue&type=style&index=0&id=d3cb9ad6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3cb9ad6",
  null
  
)

export default component.exports